import axios from 'axios';

const reportClientApi = async (values, token, langIsoCode) => {
  const url = '/SaloonOrder/complaint';
  try {
    const res = await axios.post(url, values, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
        lang: langIsoCode
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default reportClientApi;
